export default {
  namespaced: true,
  state: {
    summary: [],
    selectedYear: "",
    summaryVisible: false
  },
  mutations: {
    setSummary(state, summary) {
      state.summary = summary;
    },
    setSelectedYear(state, selectedYear) {
      state.selectedYear = selectedYear;
    },
    setSummaryvisible(state) {
        state.summaryVisible = true;
        setTimeout(() => {
            let table = document.querySelector(".js-joining-payment-summary");
            if (table) {
                table.scrollIntoView({ behavior: 'smooth' });
            }
        }, 0) 
    }
  }
}